import {takeLatestF, putAll, showSuccess} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {call, put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {t} from 'app/translations';
import {renderCsvImortMessage} from 'utils/render-csv-import-message';
import {showBeError} from 'utils/show-be-error';

import {AddAnimalsFromCsvAction} from '../action';
import {updateAnimalSessionAfterAddition} from './update-animals-session';

function* execute({payload: {animalType, file}}: AddAnimalsFromCsvAction): SagaIterator {
    const response = yield* call(Api.cabImportAnimalsFromCsv, file, {animalType});
    const title = t('animalBrowser')('addAnimalsFromFile');

    if (response.isSuccess) {
        const importResult = response.data;

        yield* put(showSuccess(title, renderCsvImortMessage(importResult), false, 'add-animals-from-csv'));
        yield* call(updateAnimalSessionAfterAddition, animalType, importResult.addedAnimals);
    } else {
        yield putAll(showBeError(response, title));
    }
}

/**
 * Handles CSV imports for the add-animals flow and refreshes the current session.
 *
 * @returns The saga watcher for `ADD_ANIMALS_FROM_CSV`.
 */
export function* addAnimalsFromCsvSaga(): SagaIterator {
    yield takeLatestF('animalBrowser/ADD_ANIMALS_FROM_CSV', execute);
}
